import { render, staticRenderFns } from "./AddGateway.vue?vue&type=template&id=0c7f9ba8"
import script from "./AddGateway.vue?vue&type=script&lang=js"
export * from "./AddGateway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports